<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <p class="page_title"> 커뮤니티 </p>
                <div class="board_wrap">
                    <div class="board_search_box">
                        <input type="text" name="" id="" v-model="list.search" @keydown.enter="searchContents">
                        <button type="button" @click="searchContents">검색</button>
                    </div>
                    <table class="list_board">
                        <colgroup>
                            <col width="auto">
                            <col width="120px">
                        </colgroup>
                        <tbody v-if="list.length > 0">
                            <tr v-for="item in list.data">
                                <template v-if="item.isImportant === 1">
                                    <td>
                                        <router-link to="#" class="notice" @click="moveDetail(item.idx)">
                                            <span class="impo">공지</span>
                                            {{ item.title }}
                                        </router-link>
                                    </td>
                                    <td class="date">
                                        {{ item.updateDate !== null ?
                                            formatDate(item.updateDate) :
                                            formatDate(item.createDate) }}
                                    </td>
                                </template>
                            </tr>
                            <tr v-for="item in list.data">
                                <template v-if="item.isImportant === 0">
                                    <td>
                                        <router-link to="#" @click="moveDetail(item.idx)">
                                            <p v-html="item.title"></p>
                                        </router-link>
                                        <div class="list_info">
                                            <span>
                                                <img src="@/assets/user/bo_view_ico.png" alt="">
                                                <b>{{ item.cntRead }}</b>
                                            </span>
                                            <span>
                                                <img src="@/assets/user/bo_good_ico.png" alt="">
                                                <b>{{ item.cntGood }}</b>
                                            </span>
                                            <span>
                                                <img src="@/assets/user/bo_bad_ico.png" alt="">
                                                <b>{{ item.cntBad }}</b>
                                            </span>
                                            <span>
                                                <img src="@/assets/user/bo_comment_ico.png" alt="">
                                                <b>{{ item.cntComment }}</b>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="date">{{ item.updateDate !== null ?
                                        formatDate(item.updateDate) : formatDate(item.createDate) }}
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                        <div v-if="list.length === 0" class="no_list">
                            <p>게시글이 없습니다.</p>
                        </div>
                    </table>
                    <div class="board_btns">
                        <router-link to="#" @click="$router.push('/community/write')">글쓰기</router-link>
                    </div>
                    <PageBtn :totalLength="list.length" :perPage="list.size" :current-page="list.currentPage"
                        @onPaging="handlePageChange">
                    </PageBtn>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :content="state.modalContent" @close="modalClose"> </ModalComponent>
</template>
<script lang="ts" config>
import {
    DataGrid,
    ModalComponent,
    HeaderLayout,
    GnbLayout,
    apiService,
    onMounted,
    reactive,
    router,
    formatDate,
    PageBtn,
    sortListDate,
} from "@/BaseComponent";
export default {
    props: {},
    components: {
        ModalComponent,
        HeaderLayout,
        GnbLayout,
        PageBtn,
    },
    setup() {
        const state = reactive({
            modalContent: "" as string,
            isModalOpen: false as boolean,
        });
        const list = reactive({
            tag: 0 as number,
            data: [] as any[],
            category: [] as any,
            search: "" as string | null,
            size: 8 as number,
            length: 0 as number,
            cntRead: 0 as number,
            currentPage: 1 as number,
            totlapage: 0 as number,
        });

        const handlePageChange = (page: number) => {
            list.currentPage = page;
            getList();
        };

        onMounted(() => {
            getList();
        });

        const getList = async () => {
            let res = await apiService.community.getList(list.currentPage, list.size, list.search);
            if (res.returnCode === 0) {
                list.length = res.data.recordsTotal;
                list.totlapage = res.data.totalPages;
                list.data = res.data.data;
                sortListDate(list.data);
            } else {
                state.modalContent = res.description;
                state.isModalOpen = true;
            }
        };

        const moveDetail = (index: number) => {
            router.push({ path: "/community/detail/" + index });
        };

        const searchContents = () => {
            list.currentPage = 1;
            getList();
        };

        const modalClose = () => {
            state.isModalOpen = false;
        };


        return {
            state,
            list,
            handlePageChange,
            moveDetail,
            searchContents,
            modalClose,
            formatDate,
        };
    },
};
</script>
<style scoped>
.search_box {
    border: 1px solid gray;
    border-radius: 5px;
}

.search_btn {
    background-color: lightgray;
    border-radius: 5px;
}
</style>
